
<div class="imageSelectionDiv">
  <v-icon v-show="imageLoaded" class="viewIcon" color="white" @click="openPreview">
    visibility
  </v-icon>
  <ImagePreview ref="imagePreview"
                :favorite-editable="favoriteEditable"
                :filter="filter"
                :image="image"
                :show-favorite-icon="showFavoriteIcon"
                :small-height="smallHeight"
                :small-width="smallWidth"
                class="imagePreview"
                doNotOpenOnClick
                @select_image="onSelect()"
                @small-loaded="imageLoaded = true"
  />
</div>
